export function getScoreColorClass(score: number): string {
  if (score >= 0.90) return 'bg-red-600';
  if (score >= 0.80) return 'bg-red-400';
  if (score >= 0.5) return 'bg-orange-400';
  if (score >= 0.25) return 'bg-yellow-400';
  return 'bg-emerald-400';
}
